import theme from '../../../theme/news12'

import css from 'styled-jsx/css'

export default css.div`
  .banner {
    background: ${theme.colors.veryLightGray};
    margin: 0 auto;
    overflow: hidden;
  }  
  
  .banner.banner-leaderboardNew, .banner-middleboard {
    background: ${theme.colors.white};
  }

  .banner-custom {
    position: fixed;
    top: 0;
    left: 0;
    overflow: visible;
    background-color: transparent;
  }

  .banner-footer {
    width: 320px;
    height: 50px;
  }

  .banner-leaderboard {
    width: 300px;
    height: 250px;
    margin: 0 auto;
  }
  
  .banner-leaderboardNew {
    width: 300px;
    height: 50px;
    margin: 0 auto;
  }
  
  .banner-middleboard {
    width: 300px;
    height: 250px;
  }

  .banner-midContent {
    width: 300px;
    height: 250px;
    margin: 40px auto 60px auto;
  }

  .banner-sidebar {
    width: 300px;
    min-height: 250px;
    margin-top: 45px;
  }  
  
  .banner-homePageSidebar {
    width: 300px;
    min-height: 250px;
    margin-left: 15px;
  }
  
  .banner-storiesCollection {
    width: 300px;
    height: 250px;
  }
  
  @media only screen and (min-width: 768px) {
    .banner.banner-leaderboardNew, .banner-middleboard {
      background: ${theme.colors.drWhite};
    }
  
    .banner-leaderboardNew {
      width: 728px;
      height: 90px;
    }
  }

  @media only screen and (min-width: 808px) {
    .banner-leaderboard {
      width: 728px;
      height: 90px;
    }
  }

  @media only screen and (min-width: 1280px) {
    .banner-midContent {
      width: 728px;
      height: 90px;
      margin-top: 20px;
    }
  }

  @media only screen and (min-width: 728px) {
    .banner-footer {
      width: 728px;
      height: 90px;
    }
  }
`
